import { observable, action } from "mobx";

class DashboardStore {
  @observable tabSelectedIndex = 0

  @action
  changeDashboardTabIndex(index) {
    this.tabSelectedIndex = index
  }
}

export default new DashboardStore();



// WEBPACK FOOTER //
// ./src/modules/dashboard/DashboardStore.js